// Equivalent of the previous chart.umd.js build: every component registered.
import Chart from 'chart.js/auto'

window.Chart = Chart
